import LicensingMain from "./LicensingMain.vue"
import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"
import {
	Route
} from "@/types"

export const route: Route[] = [
	{
		path: "/licensing",
		name: "Licensing",
		component: LicensingMain,
		meta: {
			layout: SidebarWithHeader,
			module: "licensing"
		}
	},
]

